import stylesLink from '@jane/bloom/components/productListingPage/styles.css?url';
import desktopStylesLink from '@jane/bloom/components/productListingPage/styles.desktop.css?url';
import mobileStylesLink from '@jane/bloom/components/productListingPage/styles.mobile.css?url';

export const plpStylesLinks = [
  { href: stylesLink, rel: 'stylesheet' },
  { href: desktopStylesLink, media: '(min-width: 767px)', rel: 'stylesheet' },
  { href: mobileStylesLink, media: '(max-width: 767px)', rel: 'stylesheet' },
];
